import React from 'react';
import LiteYouTubeEmbed from 'react-lite-youtube-embed';
// import { Tweet } from 'react-tweet';
import { withRef } from '@udecode/cn';
import { withHOC } from '@udecode/plate-common';
import {
  ELEMENT_MEDIA_EMBED,
  parseTwitterUrl,
  parseVideoUrl,
  useMediaState,
} from '@udecode/plate-media';
import {
  Resizable,
  ResizeHandle,
  ResizableProvider,
  // useResizableStore,
} from '@udecode/plate-resizable';

import { MediaPopover } from './MediaPopover';

import './embed/embed.scss';
import './media.scss';

const providersPadding = {
  youtube: '56.2061%',
  vimeo: '56.25%',
  youku: '56.25%',
  dailymotion: '56.0417%',
  coub: '51.25%',
  youtubeShorts: '177.78%',
};

export const MediaEmbedElement2 = withHOC(
  ResizableProvider,
  withRef((props, ref) => {
    const {
      children,
      className,
      attributes,
      style,
    } = props || {};
    const {
      align = 'center',
      embed,
      isTweet,
      isVideo,
      isYoutube,
    } = useMediaState({
      urlParsers: [parseTwitterUrl, parseVideoUrl],
    });

    // const width = useResizableStore().get.width();
    const provider = embed?.provider;
    const providerPadding =
    provider !== 'twitter'
      ? (provider && providersPadding[provider]) || '56.0417%'
      : undefined;

    return (
      <MediaPopover pluginKey={ELEMENT_MEDIA_EMBED}>
        <div
          className={className}
          ref={ref}
        >
          <figure
            className="slate-ui-media"
            contentEditable={false}
            style={style}
            {...attributes}
          >
            <Resizable
              align={align}
              className="slate-ui-media__resize"
              options={{
                align,
                maxWidth: isTweet ? 550 : '100%',
                minWidth: isTweet ? 300 : 100,
              }}
            >
              <ResizeHandle
                className="slate-ui-media__resize-handle slate-ui-media__resize-handle--left"
                options={{ direction: 'left' }}
              />

              {isVideo ? (
                isYoutube ? (
                  <LiteYouTubeEmbed
                    id={embed.id}
                    title="youtube"
                  />
                ) : (
                  <div
                    className="slate-embed"
                    style={{ paddingBottom: providerPadding }}
                  >
                    <iframe
                      allowFullScreen
                      className="slate-embed__iframe"
                      src={embed.url}
                      title="embed"
                    />
                  </div>
                )
              ) : null}
              <ResizeHandle
                className="slate-ui-media__resize-handle slate-ui-media__resize-handle--right"
                options={{ direction: 'right' }}
              />
            </Resizable>
          </figure>

          {children}
        </div>
      </MediaPopover>
    );
    /* eslint-enable max-len */
  }),
);
